module.exports = __webpack_public_path__ + "static/media/profpict-nonformal.cf9580b5.jpg";